<ejs-tab #tabObj Selecting="Select" id="ic-element" class="mt-2" [animation]="animation" heightAdjustMode="fill" (selecting)="select($event)" (created)="tabGroupCreated()">
  <e-tabitems>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.import-configuration.edit.file.general-name' | translate}}
        @if(generalTabInvalid){
          <span class="icon-warning--alt text-warning"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-file-general></app-file-general>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.import-configuration.edit.file.column-based-name' | translate}}
        @if(fieldAssignmentsInvalid){
          <span class="icon-warning--alt text-warning"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-file-column-based></app-file-column-based>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.import-configuration.edit.file.edifact-name' | translate}}
        @if(fieldAssignmentsInvalid){
          <span class="icon-warning--alt text-warning"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-file-edifact></app-file-edifact>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.import-configuration.edit.file.acodis-name' | translate}}
        @if(acodisForm.invalid){
          <span class="icon-warning--alt text-warning"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-file-acodis></app-file-acodis>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.import-configuration.edit.file.filter-name' | translate}}
      </ng-template>
      <ng-template #content>
        <app-file-filter [filterDTO]="configuration?.fileConfig?.filter" (filterUpdated)="onFilterUpdated($event)"></app-file-filter>
      </ng-template>
    </e-tabitem>
  </e-tabitems>
</ejs-tab>
